/* Small pure state helpers shared by the live picker and its regression checks. */
(function (root) {
  'use strict';
  const normalize = value => String(value ?? '').normalize('NFKC').trim().toLowerCase().replace(/[\s_\-/]+/g, ' ');
  const matches = (variant, values, ignored = -1) => values.every((value, index) => index === ignored || value === '' || value == null || String(variant.options[index]) === String(value));
  const exact = (variants, values) => values.every(value => value !== '' && value != null) ? variants.find(variant => variant.options.length === values.length && matches(variant, values)) : undefined;
  const available = (variants, values, index, value) => variants.some(variant => variant.available && String(variant.options[index]) === String(value) && matches(variant, values, index));
  const mediaFor = (variants, values, colorIndexes) => {
    const current = exact(variants, values);
    if (current?.featured_media?.id != null) return current.featured_media.id;
    const matchingColor = variants.filter(variant => colorIndexes.length && colorIndexes.every(index => String(variant.options[index]) === String(values[index])) && variant.featured_media?.id != null);
    return (matchingColor.find(variant => variant.available) || matchingColor[0])?.featured_media?.id ?? null;
  };
  const palette = {
    "black": "#20201f",
    "white": "#f5f3ed",
    "bone": "#e7e0d0",
    "ivory": "#eee9dc",
    "cream": "#e8dfc8",
    "beige": "#c9b89e",
    "sand": "#c9b99c",
    "ecru": "#d9cfb9",
    "stone": "#bcb5a6",
    "taupe": "#9a8b7b",
    "khaki": "#9b9274",
    "olive": "#6d7254",
    "green": "#47705a",
    "blackish green": "#293d35",
    "dark green": "#324a3d",
    "mint": "#afc9b6",
    "sage": "#a3ac95",
    "pink": "#d8a9b3",
    "dull red": "#9c5652",
    "red": "#b9433c",
    "burgundy": "#6c343b",
    "wine": "#67323b",
    "blue": "#557598",
    "navy blue": "#27344a",
    "navy": "#27344a",
    "flower gray": "#8f9396",
    "gray": "#90918f",
    "grey": "#90918f",
    "light gray": "#c6c6c2",
    "light grey": "#c6c6c2",
    "dark gray": "#535652",
    "dark grey": "#535652",
    "charcoal": "#3b3d3a",
    "coffee": "#695247",
    "brown": "#775d4c",
    "apricot": "#d8ae8e",
    "orange": "#c87b3b",
    "yellow": "#d7bc66",
    "purple": "#78617d",
    "lilac": "#b7a8c7",
    "lavender": "#b7a8c7",
    "silver": "#c3c5c2",
    "gold": "#b69a5e",
    "schwarz": "#20201f",
    "weiß": "#f5f3ed",
    "weiss": "#f5f3ed",
    "grau": "#90918f",
    "hellgrau": "#c6c6c2",
    "dunkelgrau": "#535652",
    "rot": "#b9433c",
    "blau": "#557598",
    "dunkelblau": "#27344a",
    "grün": "#47705a",
    "gruen": "#47705a",
    "braun": "#775d4c",
    "rosa": "#d8a9b3",
    "gelb": "#d7bc66",
    "noir": "#20201f",
    "blanc": "#f5f3ed",
    "مشکی": "#20201f",
    "سفید": "#f5f3ed",
    "طوسی": "#90918f",
    "قرمز": "#b9433c",
    "آبی": "#557598",
    "سبز": "#47705a",
    "jeans blue": "#718ba8",
    "denim blue": "#627f9d",
    "denim": "#627f9d",
    "light denim": "#91a9bd",
    "dark denim": "#364f6b",
    "light blue": "#a5c4da",
    "sky blue": "#8ebcda",
    "baby blue": "#b3cede",
    "royal blue": "#3658a1",
    "cobalt blue": "#3457a1",
    "ice blue": "#c3d7df",
    "dusty blue": "#8b9faf",
    "steel blue": "#6e8798",
    "midnight blue": "#242e45",
    "dark blue": "#354765",
    "sapphire blue": "#365989",
    "peacock blue": "#397d8a",
    "ocean blue": "#407d95",
    "petrol blue": "#37636c",
    "teal": "#3c7775",
    "turquoise": "#65b1af",
    "aqua": "#89c6c8",
    "light pink": "#ecc4cd",
    "baby pink": "#edc9d0",
    "pastel pink": "#e7c3cd",
    "dusty pink": "#c8a0a7",
    "dusty rose": "#ba8c94",
    "rose": "#cb929f",
    "rose pink": "#d5a0ad",
    "hot pink": "#d65b91",
    "fuchsia": "#bd4f84",
    "salmon": "#dba196",
    "coral": "#d78e81",
    "peach": "#e9bda2",
    "rose red": "#b8586c",
    "heather gray": "#aaaba8",
    "heather grey": "#aaaba8",
    "light heather gray": "#c8c8c3",
    "light heather grey": "#c8c8c3",
    "dark heather gray": "#666967",
    "dark heather grey": "#666967",
    "heather charcoal": "#565a57",
    "charcoal gray": "#444845",
    "charcoal grey": "#444845",
    "ash gray": "#b6b8b3",
    "ash grey": "#b6b8b3",
    "ash": "#b6b8b3",
    "cement gray": "#a5a59f",
    "cement grey": "#a5a59f",
    "silver gray": "#bdc0bc",
    "silver grey": "#bdc0bc",
    "melange gray": "#9fa19c",
    "melange grey": "#9fa19c",
    "smoke gray": "#929793",
    "smoke grey": "#929793",
    "washed black": "#484946",
    "vintage black": "#494b47",
    "faded black": "#51524f",
    "jet black": "#1d1e1c",
    "carbon black": "#2a2c29",
    "off white": "#f1eee5",
    "snow white": "#faf9f3",
    "natural": "#e9e2d1",
    "oatmeal": "#d6ccba",
    "vanilla": "#e9dfc4",
    "light beige": "#e0d4bf",
    "dark beige": "#b5a38a",
    "camel": "#b39772",
    "tan": "#b69b7b",
    "light khaki": "#c3b99c",
    "dark khaki": "#8d8569",
    "champagne": "#deceb0",
    "wheat": "#d8c4a0",
    "light green": "#b3c6a5",
    "pastel green": "#bfd0b5",
    "sage green": "#a3ac95",
    "mint green": "#afc9b6",
    "army green": "#6b7153",
    "military green": "#666d50",
    "olive green": "#737756",
    "moss green": "#788265",
    "forest green": "#355747",
    "bottle green": "#315447",
    "hunter green": "#355647",
    "emerald green": "#4d8068",
    "grass green": "#729252",
    "pine green": "#33594c",
    "avocado green": "#8a9565",
    "light purple": "#c0afd1",
    "dark purple": "#62516d",
    "violet": "#8c719e",
    "plum": "#7b586f",
    "mauve": "#ad909f",
    "lavender purple": "#b7a8c7",
    "grape purple": "#7f6589",
    "brick red": "#a56552",
    "rust": "#a86a4e",
    "wine red": "#763b46",
    "maroon": "#6e3b40",
    "dark red": "#843f40",
    "cherry red": "#af484e",
    "scarlet": "#c74e43",
    "terracotta": "#b87d65",
    "burnt orange": "#b97943",
    "mustard": "#b7a04f",
    "mustard yellow": "#b7a04f",
    "lemon yellow": "#e6d986",
    "pale yellow": "#e8dfad",
    "light brown": "#ae8e72",
    "dark brown": "#5b463a",
    "chocolate": "#654c3e",
    "chocolate brown": "#654c3e",
    "mocha": "#897060",
    "espresso": "#4b3d35",
    "caramel": "#ae845e",
    "cocoa": "#8a6c59",
    "coffee brown": "#695247",
    "jeansblau": "#718ba8",
    "hellblau": "#a5c4da",
    "marineblau": "#27344a",
    "hellrosa": "#ecc4cd",
    "altrosa": "#c8a0a7",
    "hellgrün": "#b3c6a5",
    "dunkelgrün": "#324a3d",
    "anthrazit": "#3b3d3a",
    "natur": "#e9e2d1",
    "آبی جین": "#718ba8",
    "آبی روشن": "#a5c4da",
    "سرمه ای": "#27344a",
    "صورتی": "#d8a9b3",
    "صورتی روشن": "#ecc4cd",
    "خاکستری": "#90918f",
    "خاکستری روشن": "#c6c6c2",
    "ملانژ": "#aaaba8",
    "سبز ارتشی": "#6b7153",
    "زیتونی": "#737756",
    "قهوه ای": "#775d4c",
    "کرم": "#e8dfc8",
    "بژ": "#c9b89e",
    "بنفش": "#78617d",
    "medium blue": "#527bb0",
    "medium green": "#6f9279",
    "klein blue": "#1f43b2",
    "gray apricot": "#c6b9a4",
    "grey apricot": "#c6b9a4",
    "gray blue": "#879ba9",
    "grey blue": "#879ba9",
    "gray coffee": "#8c8075",
    "grey coffee": "#8c8075",
    "plum purple": "#845e7a",
    "eden green": "#31594b",
    "oat gray": "#d2cec1",
    "oat grey": "#d2cec1"
};
  const parsePalette = text => {
    const result = { ...palette };
    String(text || '').split(/\r?\n/).forEach(line => {
      const colon = line.indexOf(':');
      if (colon > 0) { const name = normalize(line.slice(0,colon)); const color = line.slice(colon+1).trim(); if (name && color) result[name] = color; }
    });
    return result;
  };
  const discount = (price, comparison) => comparison > price && price >= 0 ? Math.floor((comparison - price) * 100 / comparison) : 0;
  root.PVZODVariantState = Object.freeze({ normalize, exact, available, mediaFor, parsePalette, discount });
})(globalThis);
